module.exports = __webpack_public_path__ + "img/menu.ccde88b4.gif";